import React, { useEffect, useState } from "react";
import "./ApplyLeave.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import Layout from "../Components/Layout";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BigText, LightOne } from "../Assets/CSS/Text";
import ConfirmationModal from "../Components/Model/ConfirmationModal";

const ApplyLeaveForm = () => {
  const [leaveType, setLeaveType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reason, setReason] = useState("");
  const [ready, setReady] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [leaveApplyLoading, setLeaveApplyLoading] = useState(false);


  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 100); // Let layout settle
    return () => clearTimeout(timer);
  }, []);

  const navigate = useNavigate();
  const cancelLeave = () => {
    setShowPrompt(false);
  }
  const handleApplyConfirm = async (e) => {
    setLeaveApplyLoading(true); // 👈 Start spinner
    // e.preventDefault();
    const token = localStorage.getItem("token");
    const today = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD

    if (!leaveType || !fromDate || !toDate || !reason) {
      toast.error("Please fill in all required fields.");
      return;
    }

    if (fromDate < today || toDate < today) {
      toast.error("Leave dates cannot be in the past.");
      return;
    }
    if (new Date(toDate) < new Date(fromDate)) {
      toast.error("End date cannot be earlier than start date.");
      return;
    }
    // const reasonRegex = /^[a-zA-Z\s]+$/;
    // if (!reasonRegex.test(reason)) {

    //   toast.error("Reason contains invalid special characters.");
    //   return;
    // }

    const payload = {
      leaveType,
      startDate: fromDate,
      endDate: toDate,
      reason,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/leaves`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Leave applied successfully:", response.data);
      toast.success("Leave applied successfully!");

      // setTimeout(() => {
      navigate("/leave-management");
      // }, 100);
      // Optionally reset form or redirect
    } catch (error) {
      console.error("Error applying for leave:", error);
    } finally {
      setLeaveApplyLoading(false); // 👈 Stop spinner
    }
  };

  return (
    <Layout>
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="backgound-main-content">
        <div className="apply-container">
          <Icon
            icon="material-symbols:arrow-back-rounded"
            className="back-icon fs-5 mb-3"
            style={{ color: '#606060', cursor: 'pointer' }}
            onClick={() => window.history.back()}
          />
          <h6 style={BigText}>Apply for Leave:</h6>
          <p style={LightOne}>
            For leave application fill out the below details
          </p>
          <form className="leave-form"
            onSubmit={(e) => {
              e.preventDefault();
              setShowPrompt(true); // Show the confirmation modal first
            }}>
            <label>Leave Type*</label>
            <select
              value={leaveType}
              onChange={(e) => setLeaveType(e.target.value)}
              required
            >
              <option value="">Select Leave Type</option>
              <option value="Sick_Leave">Sick Leave</option>
              <option value="Casual_Leave">Casual Leave</option>
              <option value="Earned_Leave">Earned Leave</option>
            </select>

            <div className="date-section">
              <label className="mt-2">Select Duration*</label>
              <div className="date-input">
                <div>
                  <label>From*</label>
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label>To*</label>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>

            <label className="mt-2">Reason*</label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
            />

            <div className="Apply-Btn">
              <Icon icon="grommet-icons:send" />
              <button type="submit">Send Application</button>
            </div>


          </form>
          <ConfirmationModal
            show={showPrompt}
            title="Confirm Leave Apply"
            message="Are you sure you want to Apply for Leave?"
            icon="et:hourglass"
            confirmLabel="Apply"
            cancelLabel="Cancel"
            onConfirm={handleApplyConfirm}
            onCancel={cancelLeave}
            loading={leaveApplyLoading}   // 👈 pass loading prop
            loadingMessage="Processing ..." // ✅ now works
          />
        </div>
      </div>
    </Layout>
  );
};

export default ApplyLeaveForm;
